/** Normalize /user/:id JSON — supports both `{data:{...}}` and flat user objects. */
export function unwrapUserPayload(payload) {
  if (!payload || typeof payload !== "object") return null;
  if (payload.data && typeof payload.data === "object" && !Array.isArray(payload.data)) {
    return { ...payload.data };
  }
  return { ...payload };
}
